import React, {Component, Fragment} from "react";
import Swal from "sweetalert2";
import {Empty, Spin, Tooltip} from "antd";
import {pageNumber} from "../../../functions/functionGeneral";
import moment from "moment";
import Paging from "../../paging";
import AddInventaris from "./inventaris/add_inv";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import SaveIcon from "../../../assets/icons/save.svg";

export class InventarisList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            add_visible: false,
            modalReturn: false,
            prosesReturn: false,

            data: [],
            tanggalPinjam: [],
            tanggalReturn: '',
            idKembali: 0,

            pageCount: 0,
            perPage: 0,
            currentPage: 0,
            paginate: 10,
            totalData: 0,

        }
        this.handleChange = this.handleChange.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    handlePageClick(data) {
        let selected = data.selected;
        this.setState({ currentPage: selected, loading: true }, () => {
            this.loadData();
        });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            currentPage: 0,
            [name]: value
        })
    }

    selesaiPeminjaman = () => {
        let form = {
            id: this.state.idKembali,
            tanggal: this.state.tanggalReturn,
            tanggal_pinjam: this.state.tanggalPinjam
        }
        this.props.request("inventaris/selesaikan-v2", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 800,
                    })
                }
                this.setState({
                    modalReturn: false,
                    prosesReturn: false , tanggalPinjam: "", tanggalReturn: ''
                }, () => this.loadData())
            })
    }

    loadData() {
        this.setState({ loading: true })
        let form = {
            paginate: 5,
            page: this.state.currentPage + 1,
            id: this.props.match.params.karyawan_slug
        }
        this.props.request('karyawan/inventaris-list', form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        data: response.data.data,
                        totalData: response.data.total,
                        pageCount: response.data.last_page,
                        perPage: response.data.per_page,
                    })
                }
                this.setState({
                    loading: false
                })
            })
    }

    componentDidMount() {
        this.loadData()
    }

    render() {
        let no = 0;
        return (
            <Fragment>
                <AddInventaris
                    add_visible={this.state.add_visible}
                    request={(action, data, method = 'GET') => this.props.request(action, data, method)}
                    changeState={(state, callback) => {
                        this.setState(state, () => {
                            if (typeof callback != 'undefined')
                                callback()
                        })
                    }}
                    id={this.props.match.params.karyawan_slug}
                    loadData={() => this.loadData()}
                />

                <Modal size="lg" zIndex={999} isOpen={this.state.modalReturn} toggle={() => this.setState({
                    modalReturn: false, tanggalReturn: '',
                })} style={{ maxWidth: "1000px"}}>
                    <ModalHeader toggle={() => {
                        this.setState({
                            modalReturn: false, tanggalReturn: '',
                        })
                    }} className="pengumuman-modal-header">
                        <div className="pengumuman-modal-header-font">Selesaikan Peminjaman</div>
                    </ModalHeader>
                    <ModalBody className="pengumuman-modal-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="mb-2 pengumuman-label-input">Tanggal Pengembalian</label>
                                    <div>
                                        <input name="tanggalReturn" className="form-control pengumuman-input"
                                               type="date" required="" onChange={this.handleChange}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter className="pengumuman-modal-footer">
                        <button onClick={() => this.setState({
                            modalReturn: false, tanggalReturn: '',
                        })} className='pengumuman-cancel-button'>Batalkan
                        </button>
                        <button className='pengumuman-save-button' onClick={this.selesaiPeminjaman}><img alt='' src={SaveIcon}/> Simpan
                        </button>
                    </ModalFooter>
                </Modal>

                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <div className="d-flex justify-content-between" style={{
                                display: "flex", alignItems: "center", justifyContent: "space-between"
                            }}>
                                <h5>Daftar Inventaris yang dipinjam</h5>
                                <div className="">
                                    <button onClick={() => { this.setState({add_visible: true}) }} className="btn pengumuman-add-button">Pinjam Inventaris</button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            {!this.state.loading && this.state.data.length === 0 ?
                                <Empty description="Data Kosong"
                                       image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg" />
                                :
                                <table className="table mb-5">
                                    <thead>
                                    <tr>
                                        <th className="lembur-th-style">#</th>
                                        <th className="lembur-th-style">Nama Inventaris</th>
                                        <th className="lembur-th-style">Tanggal Peminjaman</th>
                                        <th className="lembur-th-style">Tanggal Pengembalian</th>
                                        <th className="lembur-th-style" width={150}>Status</th>
                                        <th className="lembur-th-style"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.loading &&
                                            <tr>
                                                <td colSpan={8}>
                                                    <Spin size="large" tip="Loading..." style={{
                                                        width: '100%',
                                                        margin: 'auto',
                                                        marginBottom: '10px',
                                                        marginTop: '10px'
                                                    }} />
                                                </td>
                                            </tr>
                                        }
                                        {this.state.data.map((item) => {
                                            no += 1
                                            return (
                                                <tr style={{backgroundColor: item.contract_status === 'active' ? '#e9ffd7' : '#fff'}}>

                                                    <th className="lembur-td-style">{pageNumber(no, this.state.perPage, this.state.currentPage)}</th>
                                                    <th className="lembur-td-style">{item.inventaris.inventaris_name}</th>
                                                    <th className="lembur-td-style">{moment(item.borrow_date).format('ll')}</th>
                                                    <th className="lembur-td-style">{item.returned_date ? moment(item.returned_date).format('ll') : "__:___:____"}</th>
                                                    <th className="lembur-td-style"
                                                        style={{color: item.returned_date ? 'green' : 'red'}} width={150}>
                                                        {item.returned_date ? "Selesai" : "Sedang Dipinjam"}
                                                    </th>
                                                    <th className="lembur-td-style">
                                                        {!item.returned_date &&
                                                            <Tooltip trigger={'click'} placement="bottom" color={'#fff'}
                                                                     zIndex={900} title={
                                                                <div className="p-2">
                                                                    <a onClick={() => {
                                                                        this.setState({
                                                                            idKembali: item._inv_karyawan_id,
                                                                            modalReturn: true,
                                                                        })
                                                                    }} className={'text-dark'}>Selesaikan Peminjaman</a>
                                                                </div>
                                                            }>
                                                                <a><i
                                                                    className="fa fa-ellipsis-v" style={{
                                                                    width: 35,
                                                                    fontSize: 18,
                                                                    padding: 11,
                                                                    color: 'rgb(51 51 51)'
                                                                }}
                                                                ></i></a>
                                                            </Tooltip>
                                                        }
                                                    </th>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            }
                            <Paging
                                className="float-right"
                                handlePageClick={this.handlePageClick}
                                pageCount={this.state.pageCount}
                                currentPage={this.state.currentPage}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default InventarisList;